<template>
  <div>
    <i
      v-for="widget in $options.widgetOptions"
      :key="widget.title"
      :id="widget.type"
      :title="widget.title"
      :class="widget.class"
      data-testid="widget-item"
      class="panel-widget-icon"
      @click="addWidget({ parentId: panelId, type: widget.type })"
    />
    <Tooltip v-for="widget in $options.widgetOptions" :key="widget.type" :target="widget.type" :text="widget.title" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import FunnelMixin from '@/components/Mixin'

export default {
  name: 'PannelWidgetOptions',
  mixins: [FunnelMixin],
  props: {
    panelId: {
      type: String,
      required: true,
    },
  },
  widgetOptions: [
    {
      title: 'Adicionar Imagem',
      class: 'fas fa-image',
      type: 'Image',
    },
    {
      title: 'Adicionar Video',
      class: 'fas fa-video',
      type: 'Video',
    },
    {
      title: 'Adicionar Texto',
      class: 'fas fa-align-left',
      type: 'Text',
    },
    {
      title: 'Adicionar Botão',
      class: 'fas fa-rectangle-wide',
      type: 'Button',
    },
    {
      title: 'Adicionar iframe',
      class: 'far fa-file-code',
      type: 'Iframe',
    },
    {
      title: 'Adicionar upsell',
      class: 'far fa-funnel-dollar',
      type: 'Upsell',
    },
  ],
  methods: {
    ...mapActions('landing', ['addWidget']),
  },
}
</script>

<style lang="scss">
.panel-widget-icon {
  margin-right: 8px;
}
</style>
